{
  "all_of": "Todo de {name}",
  "also_on": "También la ven: {names}",
  "empty_body": "Cuando alguien que sigues te agregue a una de sus listas para compartir, sus cosas aparecerán aquí.",
  "empty_find": "Buscar personas para seguir",
  "empty_heading": "Todavía nadie comparte contigo",
  "everyone": "Todos",
  "feed_empty_body": "Cuando las personas que comparten contigo agreguen cosas a una lista en la que estás, aparecerán aquí.",
  "feed_empty_heading": "Todavía no hay nada en sus listas",
  "filters_label": "Mostrar",
  "from": "Lista de {name}",
  "gift_bought": "Comprado",
  "gift_by": "{name} lo va a regalar",
  "gift_by_guest": "{name} lo va a regalar, desde el enlace de la lista",
  "gift_by_someone": "Alguien lo va a regalar",
  "gift_cta": "Yo lo regalo",
  "gift_cta_bought": "Ya lo compré",
  "gift_failed": "No se pudo guardar. ¿Lo intentas de nuevo?",
  "gift_gone": "Esto ya no está compartido contigo.",
  "gift_got": "{name} ya lo tiene.",
  "gift_keep": "Mantenerlo",
  "gift_label": "Regalar",
  "gift_let_go": "Soltarlo",
  "gift_let_go_explain": "Así otra persona podrá regalarlo.",
  "gift_mark_bought": "Marcar comprado",
  "gift_mine": "Tú lo vas a regalar",
  "gift_offline": "Estás sin conexión. Inténtalo cuando tengas conexión.",
  "gift_strip_by": "Lo regala {name}",
  "gift_strip_guest": "{name} lo regala (por enlace)",
  "gift_strip_mine": "Tú lo regalas",
  "gift_strip_taken": "Apartado",
  "gift_surprise": "Que sea sorpresa",
  "gift_surprise_off": "{name} verá que alguien lo va a regalar, pero nunca quién.",
  "gift_surprise_on": "{name} no verá que ya está apartado.",
  "gift_taken": "Otra persona ya lo va a regalar.",
  "gift_to_buy": "Por comprar",
  "gifting_empty_body": "Abre algo en Sus cosas y toca Yo lo regalo. Aparecerá aquí, listo para ir de compras.",
  "gifting_empty_heading": "Nada todavía",
  "gifting_heading": "Lo que regalo",
  "gifting_sub": "Lo que dijiste que vas a regalar, lo más próximo primero.",
  "got_badge": "{name} ya lo tiene",
  "got_short": "Ya lo tiene",
  "just_you": "Solo tú y {name} ven esto.",
  "leave": "Salir de esta lista",
  "leave_confirm": "Salir",
  "leave_explain": "Dejarás de ver {list}. {name} puede volver a agregarte.",
  "leave_failed": "Sigues en esa lista. ¿Intentar de nuevo?",
  "leave_keep": "Quedarme",
  "list_empty_body": "Cuando {name} le agregue cosas, aparecerán aquí.",
  "list_empty_heading": "Todavía no hay nada en {list}",
  "lists_label": "Listas de {name}",
  "load_failed": "No se pudo cargar lo que comparten contigo.",
  "offline": "No tienes conexión. Lo que comparten contigo aparecerá cuando vuelvas a estar en línea.",
  "others_more": {
    "one": "{count} persona más",
    "other": "{count} personas más"
  },
  "page_description": "Las cosas que comparten contigo las personas que sigues.",
  "page_title": "Sus cosas — TingThings",
  "people_label": "Personas que comparten contigo",
  "person_empty_body": "Cuando {name} agregue cosas a una lista en la que estás, aparecerán aquí.",
  "person_empty_heading": "Todavía nada de {name}",
  "retry": "Intentar de nuevo",
  "sheet_close": "Cerrar",
  "sheet_lists_label": "Listas en las que está",
  "sheet_on_list": "En {list}",
  "sheet_open_link": "Abrir el enlace",
  "strip_more": "+{count}",
  "who_sees_all": "Ver a todos ({count})",
  "who_sees_hide": "Ocultar"
}
